import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "filters"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiSelect = _resolveComponent("VueMultiSelect")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "table table-striped email-table",
    options: _ctx.options,
    onClickCapture: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectEmail($event))),
    ref: "datatable",
    key: JSON.stringify([_ctx.sourcesFilter, _ctx.recipientsFilter, _ctx.groupsFilter])
  }, {
    default: _withCtx(() => [
      _createElementVNode("thead", null, [
        _cache[6] || (_cache[6] = _createElementVNode("tr", null, [
          _createElementVNode("th", null, "From"),
          _createElementVNode("th", null, "Recipients"),
          _createElementVNode("th", null, "Groups"),
          _createElementVNode("th", null, "Subject"),
          _createElementVNode("th")
        ], -1)),
        (_ctx.showFilters)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
              _createElementVNode("th", null, [
                _createVNode(_component_VueMultiSelect, {
                  modelValue: _ctx.sourcesFilter,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sourcesFilter) = $event)),
                  options: _ctx.sources,
                  multiple: true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("th", null, [
                _createVNode(_component_VueMultiSelect, {
                  modelValue: _ctx.recipientsFilter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recipientsFilter) = $event)),
                  options: _ctx.recipients,
                  "track-by": "id",
                  label: "emailAddress",
                  multiple: true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("th", null, [
                _createVNode(_component_VueMultiSelect, {
                  modelValue: _ctx.groupsFilter,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.groupsFilter) = $event)),
                  options: _ctx.groups,
                  "track-by": "id",
                  label: "name",
                  multiple: true
                }, null, 8, ["modelValue", "options"])
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("th", null, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["options"]))
}